module.exports = __webpack_public_path__ + "static/media/avatar-default.7a115d0e.png";